const map = {
  JdReplenishList: () => import('@/views/predictRreplenishment/Jd/index.vue'), // 京东补货列表
  JdReplenishDetail: () => import('@/views/predictRreplenishment/Jd/Detail.vue') // 京东补货详情
}
export default map
